import { useEffect, useState } from "react";
import keycloak from "../keycloak";
import "../styles/LandingPage.css";
import { readRuntimeConfig } from "../config/runtime";

export default function LandingPage() {
  const [apps, setApps] = useState([]);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const boot = async () => {
      const ok = await keycloak.init({
        onLoad: "check-sso",
        checkLoginIframe: false,
        pkceMethod: "S256",
      });

      if (!ok) {
        await keycloak.login({ redirectUri: window.location.href });
        return;
      }

      setUser({
        name: keycloak.tokenParsed?.name || "Desconocido",
        email: keycloak.tokenParsed?.email || "Desconocido",
      });

      const { realm } = readRuntimeConfig();

      // 🔁 ahora leemos desde la Function (mismo shape que antes)
      const cfg = await fetch(`/api/config?realm=${encodeURIComponent(realm)}`, {
        credentials: "include",
        headers: {
          // si preferís header en vez de query:
          // "X-Realm": realm
        },
      }).then((r) => {
        if (!r.ok) return r.json().then((e) => Promise.reject(e?.error || r.statusText));
        return r.json();
      });

      // filtro por lo que el usuario tiene en resource_access
      const userClients = keycloak.tokenParsed?.resource_access || {};
      const availableApps = Object.keys(userClients)
        .filter((clientId) => cfg[clientId])
        .map((clientId) => ({
          name: cfg[clientId].name,
          description: cfg[clientId].description,
          url: cfg[clientId].url,
          bgColor: cfg[clientId].bgColor || "#ffffff",
          roles: userClients[clientId].roles || [],
        }));

      setApps(availableApps);
      setLoading(false);
    };

    boot();
  }, []);

  const handleLogout = () => {
    // Redirigí a tu dominio de Pages o propio (mejor que localhost fijo)
    const base = `${window.location.protocol}//${window.location.host}/`;
    keycloak.logout({ redirectUri: base });
  };

  if (loading) return <div className="container">Loading ...</div>;

  return (
    <div className="container">
      <div className="background"></div>

      <div className="header">
        <div className="header-content">
          <div className="avatar">👤</div>
          <div className="user-details">
            <p className="welcome-text">Welcome</p>
            <h2 className="user-name">{user?.name}</h2>
            <p className="settings">⚙️ Settings</p>
          </div>
        </div>
      </div>

      <div className="apps-container">
        {apps.length > 0 ? (
          apps.map((app) => (
            <a key={app.name} href={app.url} className="app-card">
              {app.name}
            </a>
          ))
        ) : (
          <p>No tienes acceso a ninguna aplicación.</p>
        )}
      </div>

      <button onClick={handleLogout} className="logout-button">Logout</button>
    </div>
  );
}
